<app-admin-header></app-admin-header>

<div class="admin-body">
  <app-admin-sidebar></app-admin-sidebar>

  <main class="admin-content">
    <router-outlet></router-outlet>
  </main>
</div>

<app-admin-footer></app-admin-footer>
